var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 13.5H3C2.86739 13.5 2.74021 13.4474 2.64645 13.3536C2.55268 13.2598 2.5 13.1327 2.5 13V10.2072C2.5 10.1415 2.51293 10.0765 2.53806 10.0158C2.56319 9.95515 2.60002 9.90003 2.64645 9.8536L10.1464 2.3536C10.2402 2.25983 10.3674 2.20715 10.5 2.20715C10.6326 2.20715 10.7598 2.25983 10.8536 2.3536L13.6464 5.14649C13.7402 5.24026 13.7929 5.36744 13.7929 5.50005C13.7929 5.63265 13.7402 5.75983 13.6464 5.8536L6 13.5Z",
    stroke: "#103045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4L12 7.5",
    stroke: "#103045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilBlack);
export default __webpack_public_path__ + "static/media/pencil_black.f705dc3c416e691d5ffde8f97d462ec1.svg";
export { ForwardRef as ReactComponent };